<template>
  <div class="page">
    <summary-header />
    <v-container class="contents">
      <v-row class="" dense>
        <v-col>
          <v-card tile elevation="0">
            <div class="d-flex">
              <div class="section-title">
                + LIFE Cycle
                <span class="text-caption"></span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <table class="tbl mt-3">
              <thead>
                <tr style="height: 24px">
                  <th class="title-cell text-left">
                    <div style="height: 24px; line-height: 24px; border-bottom: 2px solid grey; padding-left: 10px !important; font-size: 14px; width: 90%">연도</div>
                  </th>
                  <th :class="['text-center', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">
                    <div style="height: 24px; line-height: 24px; border-bottom: 1px solid grey; font-size: 14px">
                      {{ `'${(currentYear - 1 + n).toString().substr(2, 2)}` }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="exit-row">
                  <td class="text-center title-cell">
                    <div class="col-header"><span class="ml-3">Exit</span></div>
                  </td>
                  <td :class="['text-center', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">
                    <div :class="[n === 1 ? 'start-row' : '', n === cellLength ? '' : '']">
                      {{ exit[0][n - 1] }}
                    </div>
                  </td>
                </tr>
                <tr class="age-row">
                  <td class="text-center title-cell main" rowspan="2" style="border-bottom: 1px solid black">나</td>
                  <td :class="['text-center', exit[0][n - 1] ? 'event' : '', 'main']" v-for="n in cellLength" :key="n">{{ exit[1][n - 1] }}</td>
                </tr>
                <tr style="height: 24px; border-bottom: 1px solid black">
                  <!-- <td :class="['text-center', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">
                    <div v-if="exit[2][n - 1] !== ''" class="content-cell content-border">{{ exit[2][n - 1] }}</div>
                  </td> -->
                  <td :class="['text-center', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">
                    <img v-if="exit[2][n - 1]" height="20px" :src="getImg(exit[2][n - 1])" />
                  </td>
                </tr>
                <!-- <tr style="height: 30px; border-bottom: 1px solid black;">
                  <td class="text-center title-cell font-italic main">{{ me.birthAt }}년생</td>
                  <td :class="['text-center', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">
                    <div v-if="exit[3][n - 1].startsWith('연금')" class="pension-start content-cell">
                      {{ exit[3][n - 1] }}
                    </div>
                    <div v-if="exit[3][n - 1].endsWith('근속')" :class="['content-cell']">
                      {{ exit[3][n - 1] }}
                    </div>
                    <div v-if="exit[3][n - 1].startsWith('상배')" :class="['content-cell']">
                      {{ exit[3][n - 1] }}
                    </div>
                  </td>
                </tr> -->
                <tr class="age-row" v-if="!!wife.birthAt">
                  <td class="text-center title-cell alt" rowspan="2" style="border-bottom: 1px solid black">배우자</td>
                  <td :class="['text-center', exit[0][n - 1] ? 'event' : '', 'alt']" v-for="n in cellLength" :key="n">{{ exit[3][n - 1] }}</td>
                </tr>
                <tr style="height: 24px; border-bottom: 1px solid black" v-if="!!wife.birthAt">
                  <td :class="['text-center', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">
                    <img v-if="exit[4][n - 1]" height="20px" :src="getImg(exit[4][n - 1])" />
                  </td>
                </tr>
                <template v-for="(child, k) in children">
                  <tr class="age-row" :key="child.seq + 'chage'">
                    <td class="text-center title-cell bottom-border" rowspan="2">
                      {{ `자녀 ${k + 1}` }}
                      <span class="font-italic font-weight-regular">({{ child.birthAt }}년생)</span>
                    </td>
                    <td :class="['text-center', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">{{ childProp[0][k][n - 1] }}</td>
                  </tr>
                  <tr style="height: 24px; border-bottom: 1px solid grey" :key="child.seq + 'ch'">
                    <td :class="['text-center', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">
                      <img v-if="childProp[1][k][n - 1]" height="20px" :src="getImg(childProp[1][k][n - 1])" />

                      <div v-if="childProp[1][k][n - 1] === '졸업'" class="content-cell content-border">{{ childProp[1][k][n - 1] }}</div>
                    </td>
                  </tr>
                </template>
                <template v-for="(p, k) in parents">
                  <tr class="age-row" :key="p.seq + 'age'">
                    <td :class="['text-center', 'title-cell', k % 2 === 1 ? 'main' : 'alt', 'bottom-border']" rowspan="2">
                      부모님{{ k + 1 }}
                      <span class="font-italic font-weight-regular">({{ p.birthAt }}년생)</span>
                    </td>
                    <td :class="['text-center', exit[0][n - 1] ? 'event' : '', k % 2 === 1 ? 'main' : 'alt']" v-for="n in cellLength" :key="n">{{ parentsProp[0][k][n - 1] }}</td>
                  </tr>
                  <tr style="height: 40px; border-bottom: 1px solid grey" :key="p.seq + 'pa'">
                    <!-- <td :class="['text-center', 'title-cell', 'font-italic', k % 2 === 1 ? 'main' : 'alt']">{{ p.birthAt }}년생</td> -->
                    <td :class="['text-center', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">
                      <img v-if="parentsProp[1][k][n - 1]" height="20px" :src="getImg(parentsProp[1][k][n - 1])" />
                      <!-- <div v-if="parentsProp[1][k][n - 1] !== ''" class="content-cell content-border">{{ parentsProp[1][k][n - 1] }}</div> -->
                    </td>
                  </tr>
                </template>
                <tr height="25px">
                  <td colspan="20" style="" class="text-left font-italic darkgrey--text">
                    <img height="22px" style="transform: translateY(5px)" :src="getImg('결혼')" />
                    <span style="">막내결혼 시점</span>
                    ,
                    <img style="transform: translateY(5px)" height="22px" :src="getImg('연금')" />
                    <span>국민연금</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card tile flat>
            <div class="d-flex">
              <div class="section-title">
                LIFE DESIGN Comments
                <span class="text-caption">Family</span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pl-0 pt-3">
              <v-row>
                <v-col cols="6">
                  <p class="question mb-0"><span class="subtitle-2">가족구성</span></p>
                  <p class="text-h6 mb-0 ans">{{ familyInfo }}</p>
                </v-col>
                <v-col cols="6">
                  <p class="question mb-0">
                    <span class="subtitle-2">책임경감시점</span>
                    (가장으로서 경제적 부담 감소)
                  </p>
                  <p class="text-h6 mb-0 ans">{{ `1st ${getExit[0].age}세,  2nd ${getExit[1].age}세` }}</p>
                </v-col>
                <v-col cols="6">
                  <p class="question mb-0">
                    <span class="subtitle-2">일로부터 완전한 은퇴</span>
                    (예상)
                  </p>
                  <p class="text-h6 mb-0 ans">
                    {{ me.retire + '세' }}
                  </p>
                </v-col>
                <v-col cols="6">
                  <p class="question mb-0">
                    <span class="subtitle-2">국민연금 수령</span>
                  </p>
                  <p class="text-h6 mb-0 ans">
                    {{ me.pension + '세' }}
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card tile flat>
            <div class="d-flex">
              <div class="section-title">
                LIFE DESIGN Comments
                <span class="text-caption">2nd Life 준비도</span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pl-0 pt-3">
              <v-row>
                <v-col cols="6" v-for="(child, k) in children" :key="'ch' + k">
                  <p class="question mb-0">
                    <span class="subtitle-2">{{ '자녀' + (k + 1) }}</span>
                  </p>
                  <p class="text-h6 mb-0 ans">
                    {{
                      `졸업(${child.admissionAt.toString().substring(2, 4)}년, ${child.admissionAt - child.birthAt}세),  취업(${child.jobAt.toString().substring(2, 4)}년, ${
                        child.jobAt - child.birthAt
                      }세), 결혼(${child.marriedAt.toString().substring(2, 4)}년, ${child.marriedAt - child.birthAt}세) `
                    }}
                  </p>
                </v-col>
                <v-col cols="6" v-for="(parent, k) in parents" :key="'pa' + k">
                  <p class="question mb-0">
                    <span class="subtitle-2">{{ '부모' + (k + 1) }}</span>
                  </p>
                  <p class="text-h6 mb-0 ans">
                    {{ `(${currentYear - parent.birthAt}세)로 경제적 부담이 필요한 치료나 요양이 필요한 시점은 (${parent.birthAt + parent.care}년, ${parent.care}세)로 예상` }}
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card tile flat>
            <div class="d-flex">
              <div class="section-title">
                LIFE DESIGN Comments
                <span class="text-caption">생애이슈</span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pl-0 pt-3">
              <v-row>
                <v-col cols="6">
                  <p class="question mb-0"><span class="subtitle-2">현재~퇴직시점?</span></p>
                  <p class="text-h6 mb-0 ans">
                    {{ kLife[0].value }}
                  </p>
                </v-col>
                <v-col cols="6">
                  <p class="question mb-0">
                    <span class="subtitle-2">국민연금 수령시점?</span>
                  </p>
                  <p class="text-h6 mb-0 ans">{{ kLife[1].value }}</p>
                </v-col>
                <v-col cols="6">
                  <p class="question mb-0">
                    <span class="subtitle-2">국민연금 수령이후?</span>
                  </p>
                  <p class="text-h6 mb-0 ans">{{ kLife[2].value }}</p>
                </v-col>
                <v-col cols="6">
                  <p class="question mb-0">
                    <span class="subtitle-2">그외 기타 재무이슈는?</span>
                  </p>
                  <p class="text-h6 mb-0 ans">{{ kLife[3].value }}</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-footer padless color="transparent">
      <v-col class="text-center pa-0">
        <span class="caption">&copy;삼성금융경력컨설팅센터</span>
      </v-col>
    </v-footer>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapMutations, mapState, mapGetters } from 'vuex'
import SummaryHeader from './SummaryHeader.vue'
export default {
  components: { SummaryHeader },
  name: 'Family',
  data() {
    return {
      lifeIssueText: ['현재 ~ 퇴직시점?', '국민연금 수령시점?', '국면연금 수령이후?', '그외 기타 재무이슈는?'],
      icon: {
        Finance: 'mdi-finance',
        Master: 'mdi-telegram',
        Career: 'mdi-briefcase',
        Life: 'mdi-home-city-outline',
      },
      관계: 'mdi-handshake',
      커리어: 'mdi-briefcase',
      건강: 'mdi-hospital-box',
      재무: 'mdi-cash-usd-outline',
      cashFlow: [],
      opt: {
        grid: {
          width: '80%',
          left: '18%',
          hegith: '100%',
        },
      },
    }
  },
  computed: {
    ...mapState(['master', 'me', 'wife', 'children', 'parents', 'finance', 'currentYear', 'housePension', 'life']),
    ...mapGetters(['getExit', 'getFinanceGoalMoney', 'getWifeExit', 'hasWife', 'getChildrenCount', 'getParentsCount']),
    familyInfo() {
      const me = `나(${this.me.birthAt.toString().substring(2, 4)}년생)`
      const wife = this.hasWife ? `배우자(${this.wife.birthAt.toString().substring(2, 4)}년생)` : ''
      const children = `자녀(${this.getChildrenCount}명)`
      const parents = `부양부모(${this.getParentsCount}명)`

      return [me, wife, children, parents].filter((k) => k).join(', ')
    },
    kLife() {
      if (this.life === {}) return []
      return this.life['라이프-생애이슈'].value
    },
    cellLength() {
      // const nintyAt = this.me.birthAt + 91
      // console.log(nintyAt, this.currentYear)
      // return nintyAt - this.currentYear

      const seventyAt = this.me.birthAt + 71
      console.log(seventyAt, this.currentYear)
      return seventyAt - this.currentYear
    },
    crevasseAge() {
      const t = (this.exit[17] || []).slice(0)

      if (!t[0]) return '없음'
      else {
        const s = t.shift()
        const e = t.pop()

        if (!e) return '없음'
        else return s + '세부터 ' + e + '세까지'
      }
    },
    parentsProp() {
      const t = [...new Array(this.cellLength)]

      const age = this.parents.map((p) => {
        return t.map((o, i) => this.currentYear - p.birthAt + i)
      })

      const event = age.map((p, k) => {
        const careEventList = p.map((o, i) => {
          if (o === this.parents[k].care) return '가료'
          return ''
        })
        if (this.parents[k].care < age[k][0]) careEventList[0] = '가료'
        return careEventList
      })
      console.log(this.parents)
      // console.log('==>', age, event)
      return [age, event]
    },
    childProp() {
      const t = [...new Array(this.cellLength)]

      const childAge = this.children.map((child) => {
        return t.map((o, i) => this.currentYear - child.birthAt + i)
      })

      const childEvent = childAge.map((child, k) => {
        const childEventList = child.map((o, i) => {
          if (this.currentYear + i === this.children[k].jobAt) return '취직'
          if (o === this.children[k].marry) return '결혼'
          if (this.currentYear + i === this.children[k].admissionAt) return '졸업'
          return ''
        })

        if (this.children[k].admissionAt < this.currentYear) childEventList[0] = '졸업'
        if (this.children[k].marriedAt < this.currentYear) childEventList[0] = '결혼'
        if (this.children[k].jobAt < this.currentYear) childEventList[0] = '취직'
        return childEventList
      })
      console.log(childAge, childEvent)
      return [childAge, childEvent]
    },
    exit() {
      // this.setExample()
      // console.log(this.me)
      const exit = this.getExit
      const t = [...new Array(this.cellLength)]
      const l = [...new Array(this.cellLength)]
      //나이
      const m = [...new Array(this.cellLength)].map((o, i) => this.currentYear - this.me.birthAt + i)

      const w = [...new Array(this.cellLength)].map((o, i) => this.currentYear - this.wife.birthAt + i)

      const k = exit.map((o) => {
        return { ...o, index: o.year - this.currentYear }
      })

      const kk = _.orderBy(k, ['index'])
      k.forEach((e) => {
        t[e.index] = e.name
      })
      const retireIdx = t.indexOf('은퇴')
      const aloneIdx = t.indexOf('상배')
      const pensionIdx = t.indexOf('연금')

      const m2 = t.map((o, k) => {
        if (k === retireIdx - 1) return '근속'
        if (k === pensionIdx) return '연금'
        if (k === aloneIdx) return '상배'
        return ''
      }) //event
      // console.log(m2)
      const m1 = m.map((o, k) => {
        if (o === 55) return '임피'
        else if (o === 60) return '정년'
        else if (k === pensionIdx) return '연금'
        else return ''
      })
      const wife1 = this.getWifeExit
      const w1 = w.map((o) => {
        if (o === 55) return '임피'
        else if ((this.wife.retire || 0) > 60 && o === this.wife.retire) return '정년'
        else if ((this.wife.retire || 0) <= 60 && o === 60) return '정년'
        else if (o === wife1.pension.age) return '연금'
        else return ''
      })

      const w2 = w.map((o, k) => {
        if (o === this.wife.retire - 1) return '근속'
        if (o === wife1.pension.age) return '연금'
        return ''
      })

      // const exitRetire = { name: '은퇴', year: state.me.birthAt + state.me.retire + 1, age: state.me.retire + 1 }

      //t:이벤트, m:나나이 , m1: 나이벤트, w:와잉프나이 w1와이프이벤트
      const m3 = m2.map((k, i) => (m1[i] !== '' ? m1[i] : k))
      const w3 = w2.map((k, i) => (w1[i] !== '' ? w1[i] : k))
      // console.log(m3)
      return [t, m, m3, w, w3, m, m, m, m, m, m]
    },
    getInsurance() {
      const k = ((this.finance['재무-리스크'] || {}).value || []).filter((o) => !o.value)
      if (k.length === 0) return '없음'
      else return k.map((o) => o.text.split(/\s/g)[0]).join(',')
    },
    getSourcingMoney() {
      const t = _.orderBy(this.finance['재무-목적자금-우선순위'].list, ['order'], ['asc'])

      const e1 = t.shift().title
      const e2 = t.shift().title

      const k = this.finance['재무-목적자금-계획'].value

      const ep1 = Number(k.filter((o) => o.title === e1)[0].value[1]) + this.me.birthAt
      const ep2 = Number(k.filter((o) => o.title === e2)[0].value[1]) + this.me.birthAt

      return [
        [e1, ep1],
        [e2, ep2],
      ]
    },
  },
  methods: {
    ...mapMutations([]),
    getImg(event) {
      if (event === '정년') return '/images/retire.svg'
      if (event === '연금') return '/images/pension.svg'
      if (event === '결혼') return '/images/marry.svg'
      if (event === '상배') return '/images/solo.svg'
      if (event === '근속') return '/images/work.svg'
      if (event === '임피') return '/images/salary.svg'
      if (event === '취직') return '/images/job.svg'
      if (event === '가료') return '/images/care.svg'
    },
  },
}
</script>

<style lang="scss" scoped>
.summary-name {
  position: absolute;
  left: 40px;
  top: 200px;
}
.page {
  position: relative;
  border: 1px solid white;
  // width: 2480px;
  // height: 3508px;
  width: 21cm;
  height: 29.7cm;
  margin: auto;
  page-break-before: always;

  // @media print {
  //   body {
  //     width: 21cm;
  //     height: 29.7cm;
  //     margin: 30mm 45mm 30mm 45mm;
  //     /* change the margins as you want them to be. */
  //   }
  // }
  .contents {
    // border-top: 1px solid black;
    margin-top: 30px;
    height: 1070px - 30px;
    padding: 0 40px;

    .section-title {
      padding-top: 0px;
      font-weight: 900;
      font-size: 18px;
      height: 18px;
      color: #1c5eaa;
      font-family: 'SamsungSans';
    }
    .section-title-border {
      height: 20px;
      margin-left: 10px;
      flex-grow: 1;
      border-bottom: 1px solid #165caa;
    }
    .ans {
      // height: 30px;
      color: black;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 라인수 */
      -webkit-box-orient: vertical;
      white-space: normal;
      line-height: 1.2em;
      max-height: 3.6em;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .listing div.v-list-item__subtitle {
      font-size: 16px !important;
    }
    .listing div.v-list-item__title {
      font-size: 18px !important;
    }
    .listing div.v-list-item > div {
      line-height: 18px !important;
    }
    .bottom-border {
      border-bottom: 1px solid grey;
    }
    table.tbl {
      border-collapse: collapse !important;
      // table-layout: fixed;
      width: 720px;
      word-break: break-all;
      td {
        text-align: center;
        width: 30px !important;
      }

      thead tr {
        height: 30px;
        font-weight: bold;
        font-size: 18px;
      }
      tr:nth-of-type(2n) {
        // background: #f7cac9;
      }
      tr.age-row > td {
        font-size: 12px !important;
        font-weight: 600;
        font-style: italic;
      }
      div.content-cell {
        line-height: 18px;
        background: #165caa;
        color: white;
        width: 30px;
        height: 16px;
        font-size: 11px !important;
        font-weight: 600;
        margin: auto;
        transform: translateY(-16px);
      }
      div.content-border {
        border-radius: 25px 25px 25px 25px;
      }

      div.pension-start {
        border-radius: 5px 45% 45% 5px;
      }
      td div.start-row {
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;
      }
      td div.end-row {
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;
      }
      tr.exit-row {
        height: 24px;
        font-size: 10px;
        font-weight: 600;

        td div {
          line-height: 20px;
          background: grey;
          color: white;
          width: 100%;
          height: 18px;
        }
        div.col-header {
          text-align: left;
          width: 90%;
          border-radius: 0 25px 25px 0;
          background: grey;
          color: white;
        }
      }
      th,
      td :not(.title-cell) {
        white-space: nowrap;
        word-break: break-all;
        font-size: 12px;
        // border: 1px solid grey;
      }
      td.title-cell {
        overflow-wrap: break-word;
      }
      th.event,
      td.event {
        background-color: rgba(196, 196, 196, 0.7); // background-color: rgba(42, 75, 124, 0.3) !important;
        div {
          background-color: rgba(196, 196, 196, 0.7);
          // background-color: rgba(42, 75, 124, 0.6) !important;
        }
      }
      .title-cell {
        min-width: 60px !important;
        // width: 4%;
        width: 70px;

        // background-color: #2a4b7c;
        // color: white;
      }
      td.minus {
        font-weight: 600;
        color: white;
        background-color: #9b1b30;
      }
    }
    .score {
      padding: 18px;
    }
    .life-top {
      font-size: 1em;
      border-bottom: 2px solid black;
    }
    .header-col {
      border-right: 1px solid black;
    }
    .life {
      text-align: center;
      min-height: 64px;
    }
    .life-footer {
    }
    // .echarts {
    //   width: 100%;
    //   height: 100%;
    // }
    .echarts {
      height: 480px;
      width: 100%;
    }
    .good {
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-right: 1px solid grey;
    }
    .bad {
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-right: 1px solid grey;
    }
    .happy-row {
      border-top: 1px solid grey;
    }
  }
  .footer {
    border-bottom: 1px solid grey;
    display: flex;
    align-items: flex-end;
    span {
      display: inline-block;
    }
  }
}
</style>
